document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector(".mdig-open-modal")) {
		const teamLinks = document.querySelectorAll(".mdig-open-modal");
		teamLinks.forEach((link) => {
			link.addEventListener("click", (e) => {
				e.preventDefault();
				const modalID = link.getAttribute("data-id");
				const modal = document.querySelector(
					`.mdig-postsquery-card2-modal-overlay[data-id="${modalID}"]`,
				);

				if (modal) {
					modal.style.display = "flex";
					modal.setAttribute("aria-hidden", "false");
					modal.querySelector(".mdig-postsquery-card2-modal-close").focus();

					modal.addEventListener("click", (event) => {
						if (event.target === modal) {
							modal.style.display = "none";
							modal.setAttribute("aria-hidden", "true");
							link.focus();
						}
					});

					const closeButton = modal.querySelector(
						".mdig-postsquery-card2-modal-close",
					);
					closeButton.addEventListener("click", () => {
						modal.style.display = "none";
						modal.setAttribute("aria-hidden", "true");
						link.focus();
					});

					document.addEventListener("keydown", (event) => {
						if (event.key === "Escape" && modal.style.display === "flex") {
							modal.style.display = "none";
							modal.setAttribute("aria-hidden", "true");
							link.focus();
						}
					});
				}
			});
		});
	}
});
